<template>
  <div>
    <window-header></window-header>
    <nav-form :onlyIcons="true"></nav-form>
    <section>
      <article style="height: 100px; width:340px">
        <field
          name="codigo"
          widget="input"
          searchable
          label="Código"
          placeholder="Cód."
          width="50px"
          style="top:9px; left:30px;"
          :readonly="mode == 'edit'"
          inputStyle="font-weight:bold;text-align:center;"
        />
        <field
          name="nombre"
          widget="input"
          searchable
          label="Provincia"
          help="Descripcion"
          placeholder="Descripcion"
          width="200px"
          style="top:9px; left:95px;"
        />
        <field
          name="pais_id"
          widget="m2o"
          label="Pais"
          dbAdapter="pais"
          help="Pais"
          searchable
          placeholder="Pais"
          width="265px"
          style="top:49px; left:30px;"
        />
      </article>
    </section>
    <v-collapse-wrapper ref="main-collapse" :active="true">
      <div class="header" v-collapse-toggle>
        <div class="item-title">Listado</div>
        <div class="item-after">{{count}}</div>
      </div>
      <div class="my-content" v-collapse-content>
        <hot-table ref="hotTableComponent" :settings="htSettings"></hot-table>
      </div>
    </v-collapse-wrapper>
  </div>
</template>
<script>
import WindowMixin from "./../components/WindowMixin.vue";
import rFormMixin from "./../components/rFormMixin.vue";
import rTableMixin from "./../components/rTableMixin.vue";
export default {
  mixins: [WindowMixin, rFormMixin, rTableMixin],
  data: function() {
    return {
      title: "Provincias",
      dbAdapter: "provincia",
      primary: "codigo",
      sequence: { name: "provincia" }
    };
  }
};
</script>
